import type { ModalType } from "@/modals/types"

export type NavTab = "map" | "hero" | "inventory" | "clan"

export const deriveActiveNavTab = (
  pathname: string,
  modals: Partial<Record<ModalType, boolean>>
): NavTab | null => {
  if (modals["hero"]) {
    return "hero"
  }
  if (modals["inventory"]) {
    return "inventory"
  }
  if (pathname === "/") {
    return "map"
  }
  return null
}
